import Image from "next/image";
import classes from "./ResourceEditInStrapiButton.module.css";

export default function ResourceEditInStrapiButton({
  resource,
  resourceDocumentId,
  fullWidth,
}: {
  resource:
    | "command terms"
    | "questions"
    | "notes"
    | "flashcards"
    | "definitions"
    | "individual topic test";
  resourceDocumentId: string;
  fullWidth?: true;
}) {
  return (
    <Image
      className={classes.strapiButton}
      width={26}
      height={26}
      src="/static/icons/strapi.png"
      alt="Edit In Strapi"
      onClick={() => {
        window.open(
          `${process.env.NEXT_PUBLIC_STRAPI_BASE_URL?.replace(
            "/api",
            ""
          )}/dashboard/content-manager/collection-types/api${getStrapiResourceAPI(
            resource
          )}/${resourceDocumentId}`,
          "_blank"
        );
      }}
    />
  );
}

function getStrapiResourceAPI(
  resource:
    | "command terms"
    | "questions"
    | "notes"
    | "flashcards"
    | "definitions"
    | "individual topic test"
) {
  switch (resource) {
    case "questions":
      return "::question.question";
    case "notes":
      return "::note.note";
    case "flashcards":
      return "::flashcard.flashcard";
    case "definitions":
      return "::definition.definition";
    case "individual topic test":
      return "::topic-test.topic-test";
    case "command terms":
      return "::command-term.command-term";
  }
}
